import React from 'react';
import './MountainRange.css';

/**
 * Decorative two-layer mountain-range silhouette anchored to the bottom of
 * the maintenance page. Stretches edge-to-edge at any width.
 */
function MountainRange() {
  return (
    <div className="MountainRange" aria-hidden="true">
      <div className="MountainRange-layer MountainRange-layer--back" />
      <div className="MountainRange-layer MountainRange-layer--front" />
    </div>
  );
}

export default MountainRange;
